import type { JobStatus } from './monitoring';

export interface JobListItem {
  job_id: string;
  job_type: 'eval-set' | 'scan';
  created_at: string;
  created_by: string;
  // Derived live by the API (K8s + warehouse). null if the server couldn't
  // determine it.
  status: JobStatus | null;
  // Samples parked waiting on a human ACP approval. Only nonzero for in-flight
  // eval-sets; 0 for everything else. Optional so an older server that predates
  // the field (real client/server version skew here) is tolerated — read as
  // `?? 0` at every use site.
  pending_interactions?: number;
}

export type JobStatusCounts = Partial<Record<JobStatus, number>>;

export interface JobsResponse {
  items: JobListItem[];
  total: number;
  page: number;
  limit: number;
  status_counts: JobStatusCounts;
}

export type JobsScope = 'mine' | 'all';

// `unknown` is local-only: the server only ever returns a value from JobStatus,
// but the badge needs a representation for "not loaded / failed to load".
export type JobBadgeStatus = JobStatus | 'unknown';

export const BADGE_STATUSES: ReadonlySet<JobBadgeStatus> =
  new Set<JobBadgeStatus>([
    'pending',
    'running',
    'waiting_for_capacity',
    'importing',
    'stuck',
    'complete',
    'failed',
    'deleted',
    'unknown',
  ]);

export interface JobsFilterState {
  scope: JobsScope;
  search: string;
  status: JobStatus | null;
  // Server-side filter (forwarded to /meta/jobs as `waiting=1`): show only runs
  // parked on a human approval (pending_interactions > 0).
  waiting: boolean;
  page: number;
}
